import { QueryClientProvider } from '@tanstack/react-query'
import { Direction } from 'radix-ui'
import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { useLanguage } from '../lib/i18n'
import { usePreference } from '../lib/preferences'
import { themePreference } from '../lib/theme'
import { Toaster } from '../ui/toaster'
import { TooltipProvider } from '../ui/tooltip'
import { queryClient } from './query-client'

/** Everything the app needs above the router: data cache, direction for Radix, tooltips, toasts. */
export function AppProviders({ children }: { children: ReactNode }) {
  const { t } = useTranslation()
  const { dir } = useLanguage()
  const [theme] = usePreference(themePreference)
  return (
    <QueryClientProvider client={queryClient}>
      <Direction.Provider dir={dir}>
        <TooltipProvider delayDuration={500} skipDelayDuration={200}>
          {children}
          <Toaster dir={dir} theme={theme} regionLabel={t('notifications')} />
        </TooltipProvider>
      </Direction.Provider>
    </QueryClientProvider>
  )
}
